













































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Debounce } from 'vue-debounce-decorator';
import _ from 'lodash';
import { Product, ProductProperty } from '@/models/product';
import { v4 as uuidv4 } from 'uuid';
import ProductGallery from '@/components/ProductGallery.vue';
import ProductStocksTable from '@/components/ProductStocksTable.vue';
import showFilesModal from '../components/showFiles.vue';
import VueQr from 'vue-qr';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'product-detail-modal',
    components: {
        ProductGallery,
        ProductStocksTable,
        showFilesModal,
        VueQr,
        Spinner,
    },
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('webInventory', ['activeProductLoading', 'activeProduct', 'cacheProducts', 'cacheProductsLoading']),
        ...mapState('productBrands', ['allProductBrands']),
        ...mapState('productCategories', ['allProductCategories']),
        ...mapState('productSectors', ['allProductSectors']),
        ...mapState('productApplications', ['allProductApplications']),
    },
})
export default class StoreProductDetailModal extends Vue {
    private currentUser!: any;
    private activeProduct!: Product;
    private activeProductLoading!: boolean;
    private cacheProducts!: any;
    public allProductCategories!: any;
    public allProductBrands!: any;
    public allProductSectors!: any;
    public allProductApplications!: any;


    private showVariationTypeahead: boolean = false;
    private searchQuery: string = '';
    private useGlobalDescription: boolean = false;
    private useGlobalProperties: boolean = false;

    private newSku: string = '';
    private newManufacturer_sku: string = '';

    public file_type: any = '';
    public src: any = '';
    public urlQr: string = `https://www.prodelec.mx`;
    public output: any = '';
    public AI_descripton: any = '';
    public properties_no_generated: any = '';
    public no_generated: any = '';
    public AI_properties: any = '';
    public disableEcommerce: boolean = true;
    public documents_assistant!: any;
    private localDataSheet: any = null;
    public originalValue: any = '';
    mounted() {
        this.initializeLocalDataSheet();
    }
    @Watch('activeProduct')
    onActiveProductChange() {

    }
    relatedProductsHeaders = [
        { thClass: 'th', key: 'img', label: '' },
        { thClass: 'th', key: 'id', label: 'SKU' },
        { thClass: 'th', key: 'name', label: 'Nombre' },
        { thClass: 'th', sortable: true, key: 'stock_total', label: 'Existencias' },
        { thClass: 'th', sortable: true, key: 'price', label: 'Precio' },
        { thClass: 'th', key: 'menu', label: '' },
    ];

    initializeLocalDataSheet() {
        this.localDataSheet = this.activeProduct.data_sheet ? { ...this.activeProduct.data_sheet } : null;
    }

    onAddProperty() {
        this.activeProduct.properties.push({
            id: uuidv4(),
            name: '',
            is_selector: false,
            value: '',
        });
    }

    onRemoveProperty(index) {
        this.activeProduct.properties.splice(index, 1);
    }

    onSetRelation(rel: string, $event: any) {
        this.activeProduct[rel] = $event.target.value;
        console.log(this.activeProduct);
    }

    onSaveProduct() {
        let newWord = '';
        this.AI_descripton = '';
        this.AI_properties = '';
        // this.initializeLocalDataSheet();
        //removing html tags for description
        if (this.activeProduct.description) {
            this.activeProduct.description = this.activeProduct.description.replace(/<[^>]*>/g, '');
        }

        if (/\s/g.test(this.newSku)) {
            this.newSku = this.newSku.replace(/\s/g, '');
        }
        if (this.activeProduct.name !== '') {
            newWord = this.capitalizeFirstLetterOfEachWord(this.activeProduct.name);
        }

        let product = {
            ...this.activeProduct,
            name: newWord,
            id: !this.activeProduct.id ? this.newSku : this.activeProduct.id,
            manufacturer_sku: !this.activeProduct.manufacturer_sku ? this.newManufacturer_sku : this.activeProduct.manufacturer_sku,
            is_active: this.activeProduct.is_active != null ? this.activeProduct.is_active : false,
        };
        this.$store.dispatch('webInventory/postOne', { product, view: this });
    }

    onSyncProduct(sku: any) {
        console.log('sync product', sku);
        this.$store.dispatch('webInventory/syncSku', sku);
    }

    capitalizeFirstLetterOfEachWord(name: string): string {
        return name.split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
    }

    onLoadOtherProduct(sku: string) {
        this.$store.dispatch('webInventory/getOne', sku);
    }

    @Watch('searchQuery')
    @Debounce(600)
    updateProductsList(search: string) {
        // console.log(search);
        if (this.searchQuery.length > 1 && this.searchQuery.trim() != '') {
            this.$store.dispatch('webInventory/cacheAll', { search, limit: 40, product: this.activeProduct });
        }
    }

    @Watch('activeProduct')
    getResources() {
        this.$store.dispatch('productCategories/getAll');
        this.$store.dispatch('productBrands/getAll');
        this.$store.dispatch('productSectors/getAll');
        this.$store.dispatch('productApplications/getAll');
        this.initializeLocalDataSheet();
    }

    @Watch('activeProductLoading')
    validateLoading() {
        //console.log('loading: ', this.activeProductLoading);
        //console.log('data Qr: ', this.urlQr);
        if (!this.activeProductLoading) {
            //console.log('change Qr data');
            this.urlQr = `https://www.prodelec.mx/tienda/producto/${this.activeProduct.id}`;
        }
    }



    setFileType(file_type: string) {
        this.file_type = file_type;
    }

    async GenerateDescription() {
        console.log(this.activeProduct.data_sheet);
        let { answer_description, final_properties, properties_no_generated } = await this.$store.dispatch('webInventory/getDocument', { vm: this, product: this.activeProduct, datasheet_save: this.localDataSheet });
        console.log(properties_no_generated);
        this.AI_descripton = answer_description;
        this.AI_properties = final_properties;
        this.properties_no_generated = properties_no_generated;
        this.no_generated = "No se han podido generar las propiedades de este producto debido a que no se ha podido obtener información de la ficha técnica proporcionada."
        if (this.activeProduct.properties.length == 0)
            this.activeProduct.properties = final_properties;
        console.log(this.activeProduct.properties.length);
    }

    copyToClipboard(respuesta: any) {
        navigator.clipboard.writeText(respuesta);
        this.$bvToast.toast('La descripción de IA se ha copiado', {
            title: 'Copia',
            variant: 'primary',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 3000,
        });
    }

    onDataSheetChange(e: any) {
        let fileFlag = false;
        switch (this.file_type) {
            case 'featured':
                if (e.target) {
                    const files = e.target.files;
                    files.forEach((file: any) => {
                        let formData = new FormData();
                        formData.append('pdf', file, file.name);
                        this.activeProduct.data_sheet = {
                            id: uuidv4(),
                            sort: null,
                            url: URL.createObjectURL(file),
                            origin: 'upload',
                            file: formData,
                            name: file.name,
                        };
                    });
                } else {
                    this.activeProduct.data_sheet = {
                        id: e.id,
                        sort: null,
                        url: `https://directus.prodelec.app/assets/${e.id}`,
                        origin: 'directus-update',
                        file: null,
                        name: e.filename_download,
                    };
                }
                this.file_type = '';
                fileFlag = true;
            default:
                if (!fileFlag) {
                    if (e.target) {
                        const files = e.target.files;
                        files.forEach((file: any) => {
                            let formData = new FormData();
                            formData.append('image', file, file.name);
                            this.activeProduct.gallery = [
                                ...this.activeProduct.gallery,
                                {
                                    id: uuidv4(),
                                    sort: null,
                                    url: URL.createObjectURL(file),
                                    origin: 'upload',
                                    file: formData,
                                    name: file.name,
                                },
                            ];
                        });
                    } else {
                        this.activeProduct.gallery = [
                            ...this.activeProduct.gallery,
                            {
                                id: e.id,
                                sort: null,
                                url: `https://directus.prodelec.app/assets/${e.id}`,
                                origin: 'directus-update',
                                file: null,
                            },
                        ];
                    }
                }
                break;
        }
    }

    onRemoveDataSheet() {
        this.activeProduct.data_sheet = '';
        this.AI_descripton = '';
        this.AI_properties = '';
    }

    onOpenFilesModal(file_type: string) {
        this.file_type = file_type;
        setTimeout(() => {
            this.$bvModal.show('show-files-modal');
        }, 400);
    }

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    canSeeDescription(roles: any) {
        let roleValidation = false;
        let user1Id = '8c39c042-be3d-4e7c-9f54-a840d655fe14'; //montufar
        let userdId = '85c1e50c-01de-4365-991f-e6fd5d52d90a'; //development
        switch (this.currentUser.role.name) {
            case 'Admin':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Developer':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'MercadoLibre Manager':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                if (this.currentUser.id != user1Id && this.currentUser.id != userdId) {
                    roleValidation = false;
                }
                break;
            default:
                roleValidation = false;
                break;
        }
        return roleValidation;
    }

    closeModal(modal_name: string) {
        this.AI_descripton = '';
        this.AI_properties = '';
        this.$bvModal.hide(modal_name);
    }

    async onGenerateQr() {
        // console.log('printing..');
        const el = this.$refs.printcontent;

        const options = {
            type: 'dataURL',
        };
        // @ts-ignore
        this.output = await this.$html2canvas(el, options);
        const link = document.createElement('a');
        link.setAttribute('download', `QR-${this.activeProduct.id}.png`);
        link.href = this.output;
        link.click();

        // console.log('done');
    }
}
